import { useCallback, useRef } from 'react';

export const useDebounceFunction = <T extends (...args: any[]) => Promise<void>>( fn: T, wait: number ) => {
  const timer = useRef<NodeJS.Timeout | null>(null);
  const isExecuting = useRef<boolean>(false);

  return useCallback((...args: Parameters<T>) => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(async () => {
      if (!isExecuting.current) {
        isExecuting.current = true;
        await fn(...args);
        isExecuting.current = false;
      }
    }, wait);
  }, [ fn, wait ]);
};
